import { useEffect, useState } from 'react';
import { TicketPriceSingleSelectionPanel } from '../models/buyticket';
import { getTicketPriceSingleSelectionPanel } from '../ticket-price';
import { SelectedTicketsByEventDateId } from '../../logic/models';
import { createAddToCartRequest } from '../../logic/sales-util';
import { AddToCartItem } from '../../stores/add-to-cart-stores/models/add-to-cart-items';

export function useTicketPrices(selectedTickets: AddToCartItem[], eventDateId: number, selectedTicketsByEventDateId: SelectedTicketsByEventDateId, refreshPriceList: boolean): [TicketPriceSingleSelectionPanel, boolean] {
    const [processing, setProcessing] = useState<boolean>(true);
    const [result, setResult] = useState<TicketPriceSingleSelectionPanel>(null);


    useEffect(() => {
        let isMounted = true;
        if (selectedTickets && selectedTickets.length > 0) {
            setProcessing(true);

            console.log("useTicketPrices", selectedTickets, eventDateId, selectedTicketsByEventDateId);
            const fetchTicketPrices = async () => {
                // TODO: Supporter les forfaits ici
                const result = await getTicketPriceSingleSelectionPanel(selectedTickets, createAddToCartRequest(eventDateId, selectedTicketsByEventDateId), [eventDateId]);
                if (isMounted) {
                    setResult(result);
                    setProcessing(false);
                }
            };
            fetchTicketPrices();
        } else {
            if (isMounted) {
                setResult(null);
                setProcessing(false);
            }
        }

        return () => {
            isMounted = false;
        };
    }, [selectedTickets, refreshPriceList, eventDateId, selectedTicketsByEventDateId]);
 
    return [result, processing];
}